// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.label_gt3p7 {
  color : var( --color-detailLabel, currentColor );
}

.value_sba2q {
  color : var( --color-detailValue, currentColor );
}

.suffix_U5l03 {
  color : var( --color-detailSuffix, currentColor );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/detail/type/DetailText.css"],"names":[],"mappings":";AACA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iDAAiD;AACnD","sourcesContent":["\n.label {\n  color : var( --color-detailLabel, currentColor );\n}\n\n.value {\n  color : var( --color-detailValue, currentColor );\n}\n\n.suffix {\n  color : var( --color-detailSuffix, currentColor );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label_gt3p7`,
	"value": `value_sba2q`,
	"suffix": `suffix_U5l03`
};
export default ___CSS_LOADER_EXPORT___;
